import React from 'react';
import {FormDialog} from 'components/core';
import {CategoriesCtx} from 'components/dataProviders/itemCategories';


export default function CategoryDialog({open, handleClose=()=>{}, onConfirm=()=>{}, categoryID=null})
{
    
    const [loading, setLoading] = React.useState(false);
    const [values, setValues] = React.useState({name: ''});
    const ctx = React.useContext(CategoriesCtx);
    
    React.useEffect(function clearOnClose(){
      if(!open){
        setValues({name: ''});
      }
    }, [open]);

    React.useEffect(function initializeValues() {

        if(categoryID === null) return; // create mode

        if(ctx.items.indexed[categoryID])
        {
            setValues(ctx.items.indexed[categoryID]);
        }
    }, [ctx, categoryID]);

    const handleConfirm = (values) => {
      setLoading(true);
      if(values.typeID === 0) values.typeID = 1;

      function apiCallback() {
        setLoading(false);
        onConfirm();
        handleClose();
      };

      if(categoryID !== null) ctx.funcs.update(categoryID, values).then(apiCallback);
      else ctx.funcs.create(values).then(apiCallback);
    }

    const handleDialogChange = (newValues) => {

      if(!newValues.iconID) newValues.iconID = -1;
      else newValues.iconID = parseInt(newValues.iconID);
      newValues = {...values, ...newValues};
      setValues(newValues);
    }
  
    const fields=[
        {
          type: "text",
          label: "Nombre",
          id: "name",
          placeholder: "",
          mandatory: true
        }
    ];

    return <FormDialog
      open={open}
      onClose={handleClose}
      onConfirm={handleConfirm}
      onChange={handleDialogChange}
      loading={loading}
      title={categoryID === null ? "Nueva Categoría" : "Editar Categoría"}
      confirm={categoryID === null ? "Crear Categoría" : "Guardar"}
      cancel="Cancelar"
      fields={fields}
      values={values}
      />
}
